import api from './api';

const API_PREFIX = '/wdac';

const getWDACResults = ({ limit, page, customerEnvId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/wdacResults${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getWDACApp = ({ customerEnvId, globalApplicationVersionId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/globalApplication/${globalApplicationVersionId}`);

const getWdacAppFileSetFiles = ({ customerEnvId, appId, fileSetId, page, limit, signal }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${appId}/fileSets/${fileSetId}/files`, {
    params: {
      Page: page,
      Limit: limit,
    },
    ...(signal ? { signal } : {}),
  });

const getAppWdacTabsDataCounts = ({ customerEnvId, globalApplicationVersionId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${globalApplicationVersionId}/appWdacTabsDataCounts`);

const getWdacResultsTabsDataCounts = ({ customerEnvId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/wdacResultsTabsDataCounts`);

const bulkUpdateGlobalAppStatus = ({ customerEnvId, globalApplicationVersionIds, status, notes }) =>
  api.post(`${API_PREFIX}/${customerEnvId}/bulkUpdateGlobalAppStatus`, {
    globalApplicationVersionIds,
    status,
    notes,
  });

const WDACResultsService = {
  getWDACApp,
  getWDACResults,
  getAppWdacTabsDataCounts,
  getWdacResultsTabsDataCounts,
  getWdacAppFileSetFiles,
  bulkUpdateGlobalAppStatus,
};

export default WDACResultsService;
